
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";

export const messages = defineMessages({
    "update_subscription": {
        id: "common.premium.cta_modal.enable_feature_message",
        defaultMessage: "This feature is available on the next plan. You can upgrade your plan from your account setting."
    },
})

export const getMessage = (message, defaultMessage) => {
    return message ?
        message :
        defaultMessage
}

export const handleClick = (e, props, setDisplayModal) => {
    e.preventDefault()
    if (!props.redirectToAccount) {
        setDisplayModal(true)
    } else {
        if (props.onClickProtected) {
            props.onClickProtected()
        }
        props.history.push("/my-account?utm_source=" + props.module)
    }
}


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/helpers.jsx